class MessageFormController {
  constructor() {
    this.initMessage();
  }

  initMessage() {
    this.message = { body: ''};
  }

  handleSubmit($event) {
    $event.preventDefault();
    const body = this.message.body.trim();
    if (body) {
      this.onMessageSubmit({message: this.message});
      this.initMessage();
    }
  }
}

export default MessageFormController;



// WEBPACK FOOTER //
// ./src/app/screens/engineer/screens/dashboard/components/message-form/message-form.controller.js